/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { spell_duration_all } from './spell_duration_all';
import type { spell_type_all } from './spell_type_all';
export type spell_full = {
  id: number;
  name: string | null;
  magic_path_id: number;
  casting_value: string | null;
  range: string | null;
  effect: string | null;
  type_lvl: spell_full.type_lvl;
  spell_types: Array<spell_type_all>;
  spell_duration: spell_duration_all;
};
export namespace spell_full {
  export enum type_lvl {
    ZERO = 'Zero',
    ONE = 'One',
    TWO = 'Two',
    THREE = 'Three',
    FOUR = 'Four',
    FIVE = 'Five',
    SIX = 'Six',
    A = 'A',
    T = 'T',
    H = 'H',
  }
}
